import React from 'react';
import type { RealestateAd, RealestateProjectAd } from '../../../types';
import type { BaseSearchAdProps } from '../SearchAdTypes';
import { AdOfTheWeekFooter, AdOfTheWeekFooterProps } from './AdOfTheWeekFooter';
import { PremiumRealestateSearchAd } from './PremiumRealestateSearchAd';

type AdOfTheWeekSearchAdProps = BaseSearchAdProps & {
    ad: RealestateAd | RealestateProjectAd;
    footer: AdOfTheWeekFooterProps;
    imageSizes?: string;
};

export function AdOfTheWeekSearchAd(props: AdOfTheWeekSearchAdProps) {
    const { ad, footer, ...passThroughProps } = props;

    const labelText =
        ad.main_search_key === 'SEARCH_ID_REALESTATE_LEISURE_SALE'
            ? 'Ukens fritidsbolig'
            : 'Ukens bolig';

    return (
        <PremiumRealestateSearchAd
            ad={ad}
            footer={() => <AdOfTheWeekFooter {...footer} />}
            label={({ className = '', classes }) => (
                <span
                    className={`${className} ${classes.badge} ${classes.info}`}
                >
                    {labelText}
                </span>
            )}
            suppressOrganisationLogo
            {...passThroughProps}
        />
    );
}
